module.exports = __webpack_public_path__ + "static/LICENCJA-fba5bd9d1a0c631175b092e80b6318db.pdf";